import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "btn-right" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "mask-box" }
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = ["poster", "src"]
const _hoisted_9 = ["src"]
const _hoisted_10 = ["src"]
const _hoisted_11 = ["src"]
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "top-box" }
const _hoisted_14 = { class: "bottom-box" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "preload" }
const _hoisted_18 = ["src"]
const _hoisted_19 = ["src"]
const _hoisted_20 = ["src"]
const _hoisted_21 = ["src"]
const _hoisted_22 = ["src"]
const _hoisted_23 = ["src"]

import {nextTick, ref, onMounted} from 'vue'
import {getChatStreamApi, getVoiceToCharacterUrlApi} from '@/api'
import router from "@/router";
import {TTSRecorder} from './js/index'
import {Base64} from 'js-base64'
import TypeIt from 'typeit'
import { CozeAPI } from '@coze/api'

const ossBaseUrl = 'https://ch-file.oss-cn-zhangjiakou.aliyuncs.com/universe/'

export default /*@__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

/* eslint-disable */
const apiClient = new CozeAPI({
  token: 'sat_AynRUSKWH4mWEB0bUPmoY54e7jrefP1eZCVEybaxYrdexCrQBW5Tk6cCtkSRac2C',
  baseURL: 'https://api.coze.cn',
})
async function cozeStream() {
  if (!resultTextData.value) {
    handleClose()
    return
  }

  try {
    const eventStream = apiClient.workflows.runs.stream({
      workflow_id: '7662209650259951667',
      app_id: '7661919457413513235',
      parameters: {
        input: resultTextData.value,
      },
    })
    for await (const event of eventStream) {
      if (event.event === 'Done') {
        ttsRecorder.setParams({
          text: messageStr.value
        })
        ljhc()
      } else {
        const { content } = event.data
        if (content) {
          messageStr.value += content.replace(/<\/br>/g, '')
          setMessageInnerHTML(content)
        }

        if (myvideo3.value.paused) {
          myvideo3.value.play()
        }
      }
    }
  } catch {
    setMessageInnerHTML("连接关闭")
    chatBtn.value = false
  }
}

function handleClose() {
  ttsRecorder.stop()
  loginIsopen.value = false
  isopen.value = false

  step.value = 1
  if (myvideo.value.paused) {
    myvideo.value.play()
  }
}

let ttsRecorder = new TTSRecorder({
  speed: 50,
  voice: 50,
  pitch: 50,
  voiceName: 'aisjiuxu',
  vcn: 'aisjiuxu',
  appId: 'f9b576d2',
  text: '',
  tte: 'UTF8',
  defaultText: '请输入您要合成的文本',
})
const activeIndex = ref(0)
const maskIsopen = ref(true)
const myvideo2 = ref()
const dzhIsoepn = ref(true)
const chatData = ref([])
const myvideo = ref()
const audioUrl = ref('home/dahzaohu.mp3')
const myAudio = ref()
const chatBtn = ref(false)
const myvideo3 = ref()
const myvideo4 = ref()
const myvideo5 = ref()
const keydownIsopen = ref(true)
let sourceList: EventSource[] = []
let btnStatus = "UNDEFINED"
// eslint-disable-next-line no-undef
const recorder = new RecorderManager("./dist");
const step = ref(1)
const textData = ref(null)
recorder.onStart = () => {
  changeBtnStatus("OPEN");
}
const isopen = ref(false)
let iatWS: any;
let resultText = "";
let resultTextTemp = "";
let countdownInterval: any;
let source: any = null;
// 用时间戳模拟登录用户
let userId: string | number;
const typeIts = ref(null);
const resultTextData = ref('')
const loginIsopen = ref(false)
const messageStr = ref('')
const problemList = ref([
  {
    name: '山西博物院藏有多少文物？'
  },
  {
    name: '山西出名的博物馆有哪些?'
  },
  {
    name: '鸟尊造型有什么特点?'
  },
  {
    name: '山西大同有哪些美食?'
  },
  {
    name: '山西有多少家国保单位?'
  }
])
const ok = () => {
  step.value = 3
  myvideo3.value.play()
  maskIsopen.value = false
  // getWebSocketUrl()
  // sourceFuc(`https://digitalhuman.chwhyun.com/api/keyue/ernie/connect/${userId}`)
}

// 这里为接入语音--------------------------------------
/**
 * 获取websocket url
 * 该接口需要后端提供，这里为了方便前端处理
 */
let websocketAbortController = null

const getWebSocketUrl = async () => {
  websocketAbortController = new AbortController()
  let websocketUrl = ''

  try {
    const res = await getVoiceToCharacterUrlApi(null, { signal: websocketAbortController.signal, bbb: 222 })
    websocketUrl = res.data
  } finally {
    websocketAbortController = null
  }

  if (!websocketUrl) {
    throw new Error('获取websocket url失败')
  }

  return websocketUrl
}

const toBase64 = (buffer) => {
  let binary = '';
  let bytes = new Uint8Array(buffer);
  let len = bytes.byteLength;
  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]); // 将字节转换为字符
  }
  return window.btoa(binary); // 将字符转换为 Base64 字符串
}

const countdown = () => {
  let seconds = 60;
  nextTick(() => {
    chatBtn.value = true
    // btnControl.innerText = `录音中（${seconds}s）`;
    countdownInterval = setInterval(() => {
      seconds = seconds - 1;
      if (seconds <= 0) {
        clearInterval(countdownInterval);
        recorder.stop();
        chatBtn.value = false
      } else {
        chatBtn.value = true
        // btnControl.innerText = `录音中（${seconds}s）`;
      }
    }, 1000);
  })
}

const changeBtnStatus = (status) => {
  nextTick(() => {
    btnStatus = status;
    if (status === "CONNECTING") {
      console.log("建立连接中")
      // btnControl.innerText = "建立连接中";
      // document.getElementById("result").innerText = "";
      resultText = "";
      resultTextTemp = "";
    } else if (status === "OPEN") {
      countdown();
    } else if (status === "CLOSING") {
      // btnControl.innerText = "关闭连接中";
    } else if (status === "CLOSED") {
      // chatBtn.value = true
      // btnControl.innerText = "开始录音";
    }
  })
}

const renderResult = (resultData) => {
  // 识别结束
  let jsonData = JSON.parse(resultData);
  if (jsonData.data && jsonData.data.result) {
    let data = jsonData.data.result;
    let str = "";
    let ws = data.ws;
    for (let i = 0; i < ws.length; i++) {
      str = str + ws[i].cw[0].w;
    }
    // 开启wpgs会有此字段(前提：在控制台开通动态修正功能)
    // 取值为 "apd"时表示该片结果是追加到前面的最终结果；取值为"rpl" 时表示替换前面的部分结果，替换范围为rg字段
    if (data.pgs) {
      if (data.pgs === "apd") {
        // 将resultTextTemp同步给resultText
        resultText = resultTextTemp;
      }
      // 将结果存储在resultTextTemp中
      resultTextTemp = resultText + str;
      resultTextData.value = resultTextTemp
    } else {
      resultText = resultText + str;
      resultTextData.value = resultText
    }
    // document.getElementById("result").innerText =
    //     resultTextTemp || resultText || "";
  }
  if (jsonData.code === 0 && jsonData.data.status === 2) {
    iatWS.close();
  }
  if (jsonData.code !== 0) {
    iatWS.close();
    console.error(jsonData);
  }
}

const connectWebSocket = async () => {
  let websocketUrl = ''
  try {
    websocketUrl = await getWebSocketUrl()
  } catch {
  }
  
  if (!websocketUrl) {
    return handleClose()
  }
  
  if ("WebSocket" in window) {
    iatWS = new WebSocket(websocketUrl);
  } else if ("MozWebSocket" in window) {
    // eslint-disable-next-line no-undef
    iatWS = new MozWebSocket(websocketUrl);
  } else {
    alert("浏览器不支持WebSocket");
    return;
  }
  changeBtnStatus("CONNECTING");
  iatWS.onopen = (e) => {
    // 开始录音
    recorder.start({
      sampleRate: 16000,
      frameSize: 1280,
    });
    let params = {
      common: {
        app_id: 'f9b576d2',
      },
      business: {
        language: "zh_cn",
        domain: "iat",
        accent: "mandarin",
        vad_eos: 5000,
        dwa: "wpgs",
      },
      data: {
        status: 0,
        format: "audio/L16;rate=16000",
        encoding: "raw",
      },
    };
    iatWS.send(JSON.stringify(params));
  };
  iatWS.onmessage = (e) => {
    renderResult(e.data);
  };
  iatWS.onerror = (e) => {
    recorder.stop();
    changeBtnStatus("CLOSED");
  };
  iatWS.onclose = (e) => {
    iatWS = null
    recorder.stop();
    changeBtnStatus("CLOSED");
    // sourceFuc(`https://digitalhuman.chwhyun.com/api/keyue/ernie/chatStream/${userId}?message=${resultTextData.value}`)
    // sourceFuc(`https://digitalhuman.chwhyun.com/api/keyue/ernie/chatStream/${userId}?message=${resultTextData.value}`)

    // 1006 表示连接被服务器关闭
    if (e.code === 1006) {
      return handleClose()
    }
    
    // 4050 表示录音时间过短（按住时间太短）
    if (e.code === 4050) {
      return handleClose()
    }

    cozeStream()
    
  };
}

recorder.onFrameRecorded = ({isLastFrame, frameBuffer}) => {
  if (!iatWS) return

  if (iatWS.readyState === iatWS.OPEN) {
    iatWS.send(
        JSON.stringify({
          data: {
            status: isLastFrame ? 2 : 1,
            format: "audio/L16;rate=16000",
            encoding: "raw",
            audio: toBase64(frameBuffer),
          },
        })
    );
    if (isLastFrame) {
      changeBtnStatus("CLOSING");
    }
  }
};
recorder.onStop = () => {
  clearInterval(countdownInterval);
};

const btnControlClick = async () => {
  // step.value = 2
  // myvideo2.value.play()
  // // messageStr.value = ''
  // if (btnStatus === "UNDEFINED" || btnStatus === "CLOSED") {
  //   messageStr.value = ''
  //   // new TypeIt('#textData', {
  //   //   speed: 190,
  //   //   startDelay: 900,
  //   // }).delete();
  //   chatBtn.value = true
  //   ttsRecorder.stop()
  //   await connectWebSocket();
  // } else if (btnStatus === "CONNECTING" || btnStatus === "OPEN") {
  //   // 结束录音
  //   // chatBtn.value = false
  //   // await recorder.stop();
  //   // isopen.value = true
  //   // // const res = await getChatStreamApi(userId, '你是谁')
  //   // console.log(resultTextData.value,'uuuuuuuuuuuuuuuuuu')
  //   // sourceFuc(`https://digitalhuman.chwhyun.com/api/keyue/ernie/chatStream/${userId}?message=${resultTextData.value}`)
  // }
}

const sourceFuc = (url) => {
  if (window.EventSource) {
    // 建立连接
    source = new EventSource(url);
    sourceList.push(source)
    /**
     * 连接一旦建立，就会触发open事件
     * 另一种写法：source.onopen = function (event) {}
     */
    source.addEventListener('open', function (e) {
      console.log("建立连接。。。ooooo")
    }, false);
    /**
     * 客户端收到服务器发来的数据
     * 另一种写法：source.onmessage = function (event) {}
     */
    source.addEventListener('message', function (e) {
      let valueText = JSON.parse(e.data)
      messageStr.value += valueText.finalResult.replace(/<\/br>/g, '')
      if (valueText.status === 'done') {
        let stringWithoutSearchString = messageStr.value.replace("done", "");
        ttsRecorder.setParams({
          text: stringWithoutSearchString
        })
        ljhc()
      } else {
        // step.value = 3
        if (myvideo3.value.paused) {
          myvideo3.value.play()
        }
        setMessageInnerHTML(valueText.finalResult);
        console.log("字符串中不包含'done'");
      }
      // console.log(messageStr.value)
    });
    /**
     * 如果发生通信错误（比如连接中断），就会触发error事件
     * 或者：
     * 另一种写法：source.onerror = function (event) {}
     */
    source.addEventListener('error', function (e) {
      if (e.readyState === EventSource.CLOSED) {
        setMessageInnerHTML("连接关闭");
        chatBtn.value = false
      } else {
      }
    }, false);
  } else {
    console.log("你的浏览器不支持SSE")
  }
}
const sourceCloseFun = () => {
  for (let i in sourceList) {
    sourceList[i].close();
  }
}
// 关闭Sse连接
const closeSse = () => {
  source?.close();
  const httpRequest = new XMLHttpRequest();
  httpRequest.open('GET', '/sse/close/' + userId, true);
  httpRequest.send();
  console.log("close");
}

// 将消息显示在网页上
const setMessageInnerHTML = (innerHTML) => {
  if (chatData.value[chatData.value.length - 1]) {
    chatData.value[chatData.value.length - 1].chat += innerHTML;
  }
}

// 监听窗口关闭事件，主动去关闭sse连接，如果服务端设置永不过期，浏览器关闭后手动清理服务端数据
window.onbeforeunload = function () {
  closeSse();
};
// 语音结束--------------------------------------
// 字转语音
ttsRecorder.onWillStatusChange = function (oldStatus, status) {
  if (oldStatus === "play" && status === 'endPlay') {
    step.value = 1
    if (resultTextData.value.includes('你有什么功能') || resultTextData.value.includes('你能干什么')) {
      isopen.value = false
    } else {
      isopen.value = true
    }
    myvideo.value.play()
    myvideo3.value.pause()
    sourceCloseFun()
  }
  if (oldStatus === "endPlay" && status === 'init') {
    loginIsopen.value = false
    if (resultTextData.value.includes('你好') || resultTextData.value.includes('您好')) {
      step.value = 4
      if (myvideo4.value.paused) {
        myvideo4.value.currentTime = 0
        myvideo4.value.play()
      }
    } else if (resultTextData.value.includes('再见')) {
      step.value = 5
      if (myvideo5.value.paused) {
        myvideo5.value.currentTime = 0
        myvideo5.value.play()
      }
    } else {
      step.value = 3
      if (resultTextData.value.includes('你有什么功能') || resultTextData.value.includes('你能干什么')) {
        isopen.value = false
      } else {
        isopen.value = true
      }
      // isopen.value = !resultTextData.value.includes('你有什么功能');
      if (myvideo3.value.paused) {
        myvideo3.value.play()
      }
    }
  }
  // 可以在这里进行页面中一些交互逻辑处理：按钮交互等
  // 按钮中的文字
  // let btnState = {
  //   init: '立即合成',
  //   ttsing: '正在合成',
  //   play: '停止播放',
  //   endPlay: '重新播放',
  //   errorTTS: '合成失败',
  // }
}
const ljhc = () => {
  if (['init', 'endPlay', 'errorTTS'].indexOf(ttsRecorder.status) > -1) {
    ttsRecorder.start()
  } else {
    ttsRecorder.stop()
  }
}
const funClick = (val: number) => {
  if (val == 1) {
    document.documentElement.requestFullscreen();
  } else if (val == 2) {
    location.reload();
  }
}

// 当前操作方式 keyboard: 键盘; button: 页面按钮
const currentOperation = ref('')
let startTime = 0

function handleStart(operation) {
  if (!keydownIsopen.value) return

  if (loginIsopen.value) return

  // 防止同时操作
  if (currentOperation.value) return
  currentOperation.value = operation

  startTime = Date.now()
  maskIsopen.value = false
  step.value = 2
  if (myvideo2.value) {
    myvideo2.value.play()
  }
  messageStr.value = ''
  chatBtn.value = true
  ttsRecorder.stop()
  connectWebSocket();
  loginIsopen.value = true
  keydownIsopen.value = false
}
function handleStop(operation) {
  // 防止同时操作
  if (currentOperation.value !== operation) return
  currentOperation.value = ''

  keydownIsopen.value = true
  chatBtn.value = false
  isopen.value = true
  recorder.stop();

  if ((Date.now() - startTime) < 500) {

    if (websocketAbortController) {
      websocketAbortController.abort()
    }

    if (iatWS) {
      iatWS.close(4050)
    }
  }
}

let isPointerDown = false
function handlePointerDown(e) {
  e.preventDefault()

  isPointerDown = true
  handleStart('button')
}
window.addEventListener('pointerup', (e) => {
  e.preventDefault()

  if (!isPointerDown) return

  isPointerDown = false
  handleStop('button')
})

onMounted(() => {
  userId = new Date().getTime();
  // nextTick(() => {
  //   btnControl = document.getElementById("btn_control");
  // })
  // 添加键盘按下事件监听器
  document.addEventListener("keydown", () => {
    handleStart('keyboard')
  });
  // 添加键盘放开事件监听器
  document.addEventListener("keyup", () => {
    handleStop('keyboard')
  });
})

// 全局禁用右键
document.addEventListener('contextmenu', e => {
  e.preventDefault()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "chat-ai" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (funClick(1))),
        src: ossBaseUrl + 'home2/quanpin.png',
        alt: ""
      }, null, 8, _hoisted_3),
      _createElementVNode("img", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (funClick(2))),
        src: ossBaseUrl + 'home2/shuaxin.png',
        alt: ""
      }, null, 8, _hoisted_4)
    ]),
    _createElementVNode("div", {
      class: "mask",
      style: _normalizeStyle({opacity:maskIsopen.value ? 1 : 0,pointerEvents:maskIsopen.value ? 'auto' : 'none'})
    }, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("img", {
          class: "maskbgi",
          src: ossBaseUrl + 'home/welcomeMaks.png',
          alt: ""
        }, null, 8, _hoisted_6),
        _createElementVNode("img", {
          class: "btn",
          onClick: ok,
          src: ossBaseUrl + 'home/djty2.png',
          alt: ""
        }, null, 8, _hoisted_7)
      ])
    ], 4),
    _createElementVNode("video", {
      ref_key: "myvideo",
      ref: myvideo,
      poster: ossBaseUrl + 'home2/yyzrkbgi.png',
      loop: "",
      playsinline: "",
      style: _normalizeStyle({zIndex:step.value == 1 ? 1 : 0}),
      src: ossBaseUrl + 'home2/dazhaohu.mp4'
    }, null, 12, _hoisted_8),
    _createElementVNode("video", {
      ref_key: "myvideo2",
      ref: myvideo2,
      loop: "",
      playsinline: "",
      style: _normalizeStyle({zIndex:step.value == 2 ? 1 : 0}),
      src: ossBaseUrl + 'home2/lingtin.mp4'
    }, null, 12, _hoisted_9),
    _createElementVNode("video", {
      ref_key: "myvideo3",
      ref: myvideo3,
      loop: "",
      playsinline: "",
      style: _normalizeStyle({zIndex:step.value == 3 ? 1 : 0}),
      src: ossBaseUrl + 'home2/huida.mp4'
    }, null, 12, _hoisted_10),
    _createElementVNode("video", {
      ref_key: "myvideo4",
      ref: myvideo4,
      loop: "",
      playsinline: "",
      style: _normalizeStyle({zIndex:step.value == 4 ? 1 : 0}),
      src: ossBaseUrl + 'home2/nihao.mp4'
    }, null, 12, _hoisted_11),
    _createElementVNode("video", {
      ref_key: "myvideo5",
      ref: myvideo5,
      loop: "",
      playsinline: "",
      style: _normalizeStyle({zIndex:step.value == 5 ? 1 : 0}),
      src: ossBaseUrl + 'home2/zaijian.mp4'
    }, null, 12, _hoisted_12),
    _createElementVNode("div", _hoisted_13, _toDisplayString(resultTextData.value ? resultTextData.value : '可以说“你好”来唤醒我'), 1),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", {
        style: _normalizeStyle({visibility: !isopen.value ? 'block' : 'hidden'}),
        class: "title"
      }, "可以试着问我", 4),
      _createElementVNode("div", {
        style: _normalizeStyle([{opacity: !isopen.value ? 1 : 0}, {"height":"8%"}])
      }, null, 4),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(problemList.value, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          style: _normalizeStyle({opacity: !isopen.value ? 1 : 0}),
          class: "problem",
          onClick: ($event: any) => (_ctx.listClick(item)),
          key: index
        }, _toDisplayString(item.name), 13, _hoisted_15))
      }), 128)),
      _createElementVNode("img", {
        class: "logings",
        style: _normalizeStyle({opacity: loginIsopen.value ? 1 : 0}),
        src: ossBaseUrl + 'home2/AIlogding.png',
        alt: ""
      }, null, 12, _hoisted_16),
      _createElementVNode("div", {
        style: _normalizeStyle({opacity: isopen.value ? 1 : 0}),
        class: "problem-box"
      }, _toDisplayString(messageStr.value), 5)
    ]),
    _createElementVNode("div", {
      class: "record-btn",
      onPointerdown: handlePointerDown
    }, [
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("img", {
          src: ossBaseUrl + 'home2/audioimg.gif'
        }, null, 8, _hoisted_18),
        _createElementVNode("img", {
          src: ossBaseUrl + 'home2/audioimgover.png'
        }, null, 8, _hoisted_19),
        _createElementVNode("img", {
          src: ossBaseUrl + 'home2/audio-press.gif'
        }, null, 8, _hoisted_20)
      ]),
      (currentOperation.value)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: ossBaseUrl + 'home2/audioimg.gif',
            class: "icon"
          }, null, 8, _hoisted_21))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (loginIsopen.value)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: ossBaseUrl + 'home2/audioimgover.png',
                  class: "icon"
                }, null, 8, _hoisted_22))
              : (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  src: ossBaseUrl + 'home2/audio-press.gif',
                  class: "icon"
                }, null, 8, _hoisted_23))
          ], 64))
    ], 32)
  ]))
}
}

})